import { useState, MouseEvent } from "react";
import adminClasses from "../../../landing-pages/admin/admin.module.css";
import IdNameModel from "../../../../models/common/IdNameModel";
import TagsInputModel from "../../../../models/common/TagsInputModel";
import InterviewerSchedulesModel from "../../../../models/interviewer/response/InterviewerSchedulesModel";
import interviewerService from "../../../../services/interviewer/interviewer-service";
import dateTimeUtils from "../../../../utils/date-utils";
import toasterUtils from "../../../../utils/toaster-utils";
import InterviewerScheduleGridComponent from "./InterviewerScheduleGridComponent";
import adminInterviewsService from "../../../../services/admin/admin-interviews-service";
import modalUtils from "../../../../utils/modal-utils";
import InterviewerSchedulesRequestModel from "../../../../models/interviewer/request/InterviewerSchedulesRequestModel";
import { GuidEnum } from "../../../../models/enums/GuidEnum";
import { Autocomplete, Button, FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import { TimeSlotsAutocomplete } from "../../../interviewer/schedule/TimeSlotsAutoComplete";


interface InterviewerSchedulesProps {
    primarySkillsList: IdNameModel[];
    timeSlotsList: IdNameModel[];
};

const InterviewerSchedulesComponent = (props: InterviewerSchedulesProps) => {
    let tagsinputList: TagsInputModel[] = props.timeSlotsList.map((item) => {
        return { id: item.id.toString(), text: item.name }
    });
    const [scheduleDate, setScheduleDate] = useState<Dayjs | null>(null);
    const [timeslotsTags, setTimeslotsTags] = useState<TagsInputModel[]>(tagsinputList);
    const [timeslotsSelected, setTimeslotsSelected] = useState<TagsInputModel[]>([]);
    const [interviewerSchedules, setInterviewerSchedules] = useState<InterviewerSchedulesModel>();
    const [refreshInterviewerScheduleGrid, setRefreshInterviewerScheduleGrid] = useState<number>(2);
    const [primarySKillSearch, setPrimarySkillSearch] = useState<number>(0);
    const [interviewerSearch, setInterviewerSearch] = useState<string>(GuidEnum.Empty);
    const [interviewerList, setInterviewerList] = useState<IdNameModel[]>([]);

    const handleDelete = (i: number) => {
        setTimeslotsSelected(timeslotsSelected.filter((tag, index) => index !== i));
    };

    const handleAddition = (tag: TagsInputModel) => {
        setTimeslotsSelected([...timeslotsSelected, tag]);
    };

    const handleDrag = (tag: TagsInputModel, currPos: any, newPos: any) => {
        const newTags = timeslotsSelected.slice();
        newTags.splice(currPos, 1);
        newTags.splice(newPos, 0, tag);
        setTimeslotsSelected(newTags);
    };

    const handleTagClick = (index: any) => {
        //console.log('The tag at index ' + index + ' was clicked');
    };

    const clearSchedule = () => {
        setPrimarySkillSearch(0);
        setInterviewerSearch(GuidEnum.Empty);
        setScheduleDate(null);
        setTimeslotsSelected([]);
        setRefreshInterviewerScheduleGrid(2);
    };

    const getInterviewerSchedule = (interviewerId: string, date: string) => {
        setRefreshInterviewerScheduleGrid(2);
        interviewerService.getInterviewerSchedules(interviewerId, dateTimeUtils.getFormattedDateFromDate(date)).then((res) => {
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            setInterviewerSchedules(res.data);
            setRefreshInterviewerScheduleGrid(refreshInterviewerScheduleGrid * 5);
        }).catch((error) => {
            toasterUtils.showError(error);
            setRefreshInterviewerScheduleGrid(refreshInterviewerScheduleGrid * 5);
        });
    };

    const getInterviewerListByPrimarySkill = (primarySkillId: number) => {
        modalUtils.showLoader();
        clearSchedule();
        setPrimarySkillSearch(primarySkillId);
        adminInterviewsService.getInterviewersByPrimarySkill(primarySkillId, GuidEnum.Empty).then((res) => {
            modalUtils.closeModal();
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            setInterviewerList(res.items);
        }).catch((error) => {
            modalUtils.closeModal();
            toasterUtils.showError(error);
        });
    };

    const saveSchedule = () => {
        if (scheduleDate === null || timeslotsSelected.length < 1 || interviewerSearch === "" || interviewerSearch === GuidEnum.Empty) {
            toasterUtils.showWarning("Please Select Interviewer Date and TimeSlots.");
        } else {
            var timslotsSaveList: InterviewerSchedulesRequestModel[] = [];
            var objTimeSlot: InterviewerSchedulesRequestModel = {
                interviewerId: interviewerSearch,
                startDate: dateTimeUtils.getFormattedDateFromDate(scheduleDate ? scheduleDate.toDate().toISOString() : new Date().toISOString()),
                endDate: dateTimeUtils.getFormattedDateFromDate(scheduleDate ? scheduleDate.toDate().toISOString() : new Date().toISOString()),
                timeSlotIds: timeslotsSelected.map(x => Number(x.id)),
                blockSchedule: false
            }
            timslotsSaveList.push(objTimeSlot);
            if (timslotsSaveList.length > 0) {
                interviewerService.saveInterviewerSchedule(timslotsSaveList).then((res) => {
                    if (!res.isSuccess || res.errorMessages.length > 0) {
                        toasterUtils.showError(res.errorMessages.toString());
                        return;
                    }
                    toasterUtils.showSuccess(res.informationMessages.toString());
                    clearSchedule();
                    getInterviewerSchedule(interviewerSearch, dateTimeUtils.getFormattedDate(scheduleDate ? scheduleDate.toDate() : new Date()));
                }).catch((error) => {
                    toasterUtils.showError(error);
                });
            }
        }
    }

    return (
        <div className="card card-white">
            <div className="card-body">
                <div className="row">
                    <div className="col-md-4">
                        <FormControl fullWidth margin="none" size="small">
                            <Autocomplete options={props.primarySkillsList} value={props.primarySkillsList.find((x) => x.id === primarySKillSearch) || null}
                                onChange={(_, newValue) => getInterviewerListByPrimarySkill(newValue ? newValue.id : 0)}
                                filterOptions={(options, state) => {
                                    return options.filter((opt) =>
                                        opt.name.toLowerCase().startsWith(state.inputValue.toLowerCase())
                                    );
                                }}
                                getOptionLabel={(option) => option?.name || ""} isOptionEqualToValue={(option, value) => option.id === value.id}
                                renderInput={(params) => (
                                    <TextField {...params} label="Primary Skill" size="small" margin="normal" fullWidth required />
                                )}
                            />
                        </FormControl>
                    </div>
                    <div className="col-md-8">
                        <FormControl fullWidth margin="none" size="small">
                            <Autocomplete options={interviewerList} value={interviewerList.find((x) => x.guId === interviewerSearch) || null}
                                onChange={(_, newValue) => {setInterviewerSearch(newValue ? newValue.guId : GuidEnum.Empty); setTimeslotsSelected([]);}} getOptionLabel={(option) => option?.name || ""} isOptionEqualToValue={(option, value) => option.guId === value.guId}
                                renderInput={(params) => (
                                    <TextField {...params} label="Interviewer" size="small" margin="normal" fullWidth required />
                                )}
                            />
                        </FormControl>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-4">
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                label="Date"
                                value={scheduleDate}
                                onChange={(newValue) => { setScheduleDate(newValue); setTimeslotsSelected([]); }}
                                format="YYYY-MMM-DD"
                                slotProps={{
                                    textField: {
                                        fullWidth: true,
                                        size: "small",
                                        margin: "normal",
                                    },
                                }}
                            />
                        </LocalizationProvider>
                    </div>
                    <div className="col-md-8">
                        <TimeSlotsAutocomplete
                            options={timeslotsTags}
                            value={timeslotsSelected}
                            onAdd={(tag) => handleAddition(tag)}
                            onDelete={(index) => handleDelete(index)}
                            onChipClick={(index) => handleTagClick(index)}
                            placeholder="Click here to Add Time Slots"
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12 text-end">
                        <Button variant="contained" color="success" disabled={scheduleDate === null || timeslotsSelected.length < 1} onClick={() => saveSchedule()} sx={{ ml: 2, mt: 2 }}>
                            Save
                        </Button>
                        <Button variant="contained" color="error" className="m-l-xxs" type="button" onClick={clearSchedule} sx={{ ml: 2, mt: 2 }}>
                            Close
                        </Button>
                    </div>
                </div>
                <div className="row">
                    {interviewerSchedules && refreshInterviewerScheduleGrid != 2 &&
                        <InterviewerScheduleGridComponent
                            key={refreshInterviewerScheduleGrid}
                            interviewerSchedule={interviewerSchedules} />
                    }
                </div>
            </div>
        </div>
    );
};
export default InterviewerSchedulesComponent;